import { render } from "./Home.vue?vue&type=template&id=2f4a7839"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=2f4a7839&lang=scss"

import exportComponent from "/home/th3g3ntl3man/github/blog/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__